import React, { useState, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
const CustomizeStationModal = lazy(
  () => import(/* webpackChunkName: "cstmzstm" */ "./CustomizeStationModal"),
);
const PlayerSettings = lazy(
  () => import(/* webpackChunkName: "plysttngs" */ "../parts/PlayerSettings"),
);
import {
  Grid,
  Tooltip,
  Snackbar,
  Dialog,
  Hidden,
  DialogTitle,
  DialogContent,
  SwipeableDrawer,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Alert } from "@material-ui/lab";

import {
  TwitterShareButton,
  TwitterIcon,
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { playerStoreContext } from "lib/player_store";
import { CopyToClipboard } from "react-copy-to-clipboard";

import LoadingSection from "../parts/LoadingSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ErrorOutline as ErrorOutlineIcon,
  Share as ShareIcon,
  Tune as TuneIcon,
} from "@material-ui/icons";
import history from "lib/history";

const MY_MIX_STATION_TYPE = 9;

const CustomizeStation = ({
  station_type,
  is_owner,
  station_id,
  user_id,
  skip,
}) => {
  console.log("CustomizeStation", station_type, is_owner, station_id, user_id);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  //const history = useHistory();

  const handleClickOpen = () => {
    // MY_MIX tuned but not editable by listener
    if (station_type == 9) {
      if (is_owner) {
        history.push(`/users/${user_id}/mixes/${station_id}/edit`);
      } else {
        setOpenEdit(true);
      }
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const share = (url) => {
  //   console.log("share", url);
  //   FB.ui(
  //     {
  //       method: "share_open_graph",
  //       action_type: "og.likes",
  //       action_properties: JSON.stringify({
  //         object: url,
  //       }),
  //     },
  //     function (response) {
  //       try {
  //         console.log("FB action publish", response);
  //       } catch (e) {}
  //     }
  //   );
  // };

  const closeShare = () => {
    setOpenShare(false);
  };

  const handleClickShare = () => {
    setOpenShare(true);
    // return share(`https://www.jango.com/stations/${station_id}/tunein`);
  };

  const handleClickSettings = () => {
    setOpenSettings(true);
  };

  const closeSettings = () => {
    setOpenSettings(false);
  };

  return (
    <div
      id="now-playing-edit-station"
      className="d-inline pl-4 pr-md-4"
      style={{ float: "right" }}
    >
      <Tooltip title="Customize Station">
        <div onClick={handleClickOpen} className="d-inline">
          <FontAwesomeIcon icon="edit" size="lg" className="fs-3 icon-action" />
        </div>
      </Tooltip>
      {station_id?.length != 32 && (
        <Tooltip title="Share Mix">
          <div onClick={handleClickShare} className="d-inline">
            <ShareIcon fontSize="large" className="ml-3 icon-action" />
          </div>
        </Tooltip>
      )}
      <Hidden smUp>
        <Tooltip title="Player Settings">
          <div onClick={handleClickSettings} className="d-inline">
            <TuneIcon fontSize="large" className="ml-3 icon-action" />
          </div>
        </Tooltip>
      </Hidden>
      <Suspense
        fallback={
          <div className="pr-2">
            <LoadingSection type="loading-icon" />
          </div>
        }
      >
        {openEdit && (
          <EditMessage
            open={openEdit}
            setOpen={setOpenEdit}
            station_id={station_id}
            user_id={user_id}
          />
        )}
        {open && <CustomizeStationModal open={open} onClose={handleClose} />}
        {openShare && (
          <ShareDialog
            open={openShare}
            onClose={closeShare}
            link={`https://www.jango.com/stations/${station_id}/tunein`}
          />
        )}
        {openSettings && (
          <SettingsDialog
            open={openSettings}
            onClose={closeSettings}
            skip={skip}
          />
        )}
      </Suspense>
    </div>
  );
};

const SettingsDialog = ({ open, onClose, skip }) => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <SwipeableDrawer
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={()=>{}}
    >
      <DialogTitle>Player Settings</DialogTitle>
      <DialogContent dividers>
        <div className="p-2">
          <Suspense fallback={null}>
            <PlayerSettings skip={skip} />
          </Suspense>
        </div>
      </DialogContent>
    </SwipeableDrawer>
  );
};

const ShareDialog = ({ open, onClose, link }) => {
  return (
    <Dialog open={open} onClose={onClose} className="BandCentralShareModal">
      <div className="band_share_container">
        <div className="band_share_header">Share This Station</div>

        <div className="band_share_share">
          <TwitterShareButton url={link}>
            <TwitterIcon size={36} round={false} />
          </TwitterShareButton>

          <FacebookShareButton url={link}>
            <FacebookIcon size={36} round={false} />
          </FacebookShareButton>

          <EmailShareButton url={link}>
            <EmailIcon size={36} round={false} />
          </EmailShareButton>
        </div>
        <div className="band_share_link" style={{ marginBottom: "1rem" }}>
          <CopyToClipboard text={link} onCopy={() => {}}>
            <input
              type="text"
              defaultValue={link}
              className="band_share_text"
              readOnly
            />
          </CopyToClipboard>
          <span>
            <CopyToClipboard text={link} onCopy={() => {}}>
              <button className="clipbtn" type="button">
                &nbsp;
              </button>
            </CopyToClipboard>
          </span>
        </div>
      </div>
    </Dialog>
  );
};

const EditMessage = ({ open, setOpen, station_id, user_id }) => {
  const useStyles = makeStyles((_theme) => ({
    alert: {
      color: "white",
      backgroundColor: "#0c4670",
      borderColor: "white",
      ".MuiAlert-outlinedInfo .MuiAlert-icon": {
        svg: { color: "#fff" },
      },
    },
    // root: {
    //   bottom: "6em",
    // },
  }));
  const classes = useStyles();

  return (
    <Snackbar
      //  className={classes.root}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "center", horizontal: "center" }}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Alert
        icon={<ErrorOutlineIcon style={{ color: "white" }} />}
        variant="outlined"
        severity="info"
        className={classes.alert}
      >
        <Link to={`/users/${user_id}/mixes/${station_id}/edit`}>
          Copy and Customize this station <FontAwesomeIcon icon="arrow-right" />
        </Link>
        <br />
        <Link to={`/stations/${station_id}`}>
          View the Station Playlist <FontAwesomeIcon icon="arrow-right" />
        </Link>
      </Alert>
    </Snackbar>
  );
};

export default CustomizeStation;
